(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('stockBatchOnLocation', {
        templateUrl: 'views/components/views/stockBatchOnLocation/stockBatchOnLocation.template.html?v=' + module.version, 
        controllerAs: 'vm',
        controller: ['$stateParams', 'stockBatchOnLocationService', 'ttGridFactory', function ($stateParams, stockBatchOnLocationService, ttGridFactory) {

            // #region VARIABLES & DEFINITIONS
            
            const vm = this;
            let stockKeyno = $stateParams.stock_keyno;
            let stockLocationKeyno = $stateParams.stocklocation_keyno;
            let functionName = $stateParams.functionname;
            let onDestroy = [];

            vm.model = {
                stockKeyno: stockKeyno,
                stockLocationKeyno: stockLocationKeyno,
                functionName: functionName,
                gridReady: false,
                gridView: false,
                gridDataLoaded: false,
                bgPickType: {
                    selected: 'stockbatchonlocation_pick_part',
                    buttons: [
                        { id: 'stockbatchonlocation_pick_part', label: 'stockbatchonlocation_pick_part', color: 'primary', onClick: function () { vm.model.bgPickType.selected = 'stockbatchonlocation_pick_part'; } },
                        { id: 'stockbatchonlocation_show', label: 'stockbatchonlocation_show', color: 'primary', onClick: function () { vm.model.bgPickType.selected = 'stockbatchonlocation_show'; } },
                    ]
                },
                setting: {},
                itemsListStockBatches: []
            };

            vm.grid = new ttGridFactory({
                rememberId: 'w_stockbatchonlocation_grid',
                kendo: {
                    height: '100%',
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            });

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE CALLS

            async function loadSetting() {
                vm.model.setting = (await stockBatchOnLocationService.getStockInfo({
                    stock_keyno: stockKeyno,
                    stocklocation_keyno: stockLocationKeyno,
                    functionname: functionName
                }))[0];
            }

            async function loadStockbatchInfoShow() {
                vm.model.itemsListStockBatches = await stockBatchOnLocationService.listStockBatchInfoShow({
                    stock_keyno: stockKeyno,
                    stocklocation_keyno: stockLocationKeyno,
                    functionname: functionName,
                    list_type: vm.model.bgPickType.selected
                });
            }

            // #endregion LOAD PROCEDURE CALLS

            // #region GRID PROCEDURE FUNCTION CALLS

            async function loadGrid() {
                vm.grid.dataTask.loadData = {
                    method: 2579,
                    parameters: {
                        stock_keyno: stockKeyno,
                        stocklocation_keyno: stockLocationKeyno,
                        functionname: functionName,
                        list_type: vm.model.bgPickType.selected
                    }
                };

                vm.model.gridReady = true;

                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
            }

            // #endregion GRID PROCEDURE FUNCTION CALLS

            // #region BUTTON RADIO FUNCTION

            vm.selectBgPickType = function (value) {
                vm.model.bgPickType.selected = value;

                if (vm.model.bgPickType.selected === 'stockbatchonlocation_pick_part') {
                    loadStockbatchInfoShow();
                } else if (vm.model.bgPickType.selected === 'stockbatchonlocation_show') {
                    if (vm.model.gridView === false) {
                        loadStockbatchInfoShow();
                    } else {
                        loadGrid();
                    }
                }
            };

            // #endregion BUTTON RADIO FUNCTION

            // #region ON WINDOW RESIZE FUNCTION

            async function onWindowResize() {
                if (window.innerWidth > 926) {
                    if (vm.model.gridView === false) {
                        vm.model.gridView = true;

                        if (vm.model.gridReady === false && vm.model.gridDataLoaded === false) {
                            loadGrid();
                            vm.model.gridDataLoaded = true;
                        }
                    }
                } else {
                    if (vm.model.gridView === true) {
                        vm.model.gridView = false;
                        loadStockbatchInfoShow();
                    }
                }
            }

            // #endregion ON WINDOW RESIZE FUNCTION

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                loadSetting();
            	window.addEventListener('resize', onWindowResize);
                onWindowResize();
                loadStockbatchInfoShow();
                loadGrid();
            }

            // #endregion ON INIT FUNCTION

            // #region DESTROY FUNCTION

            vm.$onDestroy = function () {
            	window.removeEventListener('resize', onWindowResize);

            	onDestroy.forEach((fn) => {
            		if (typeof fn === 'function') fn();
            	});
            }

            // #endregion DESTROY FUNCTION

        }]
    });
})();
